export default "__VITE_ASSET__zJ$7w0Jp__"